import {getOnboardedCountriesUseCase} from '@/useCases/getOnboardedCountriesUseCase'
import {useQuery} from '@tanstack/react-query'

export const ONBOARDED_COUNTRIES_QUERY_KEY = ['onboardedCountries']

// shared by the table and the add country modal; both read from the same cached query
export const useOnboardedCountries = () =>
  useQuery({
    queryKey: ONBOARDED_COUNTRIES_QUERY_KEY,
    queryFn: ({signal}) => getOnboardedCountriesUseCase(signal),
  })
